import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import { Navbar } from './components/Navbar';
import { Landing } from './pages/Landing';
import { VillaDetails } from './pages/VillaDetails';
import { AgentLogin } from './pages/AgentLogin';
import { AgentDashboard } from './pages/AgentDashboard';
import { AgentNewBooking } from './pages/AgentNewBooking';
import { AdminDashboard } from './pages/AdminDashboard';
import { useScreenInit } from './useScreenInit';
function AppContent() {
  useScreenInit();
  return <div className="min-h-screen bg-surface flex flex-col" data-id="element-0" data-mp="31agn4l9h89hv">
      <Navbar data-id="element-1" data-mp="31c1ha9rvpqf7" />
      <main className="flex-grow" data-id="element-2" data-mp="31cjmvx0flgzs">
        <Routes data-id="element-3" data-mp="2wjgq7g0cxrfd">
          <Route path="/" element={<Landing data-id="element-5" data-mp="2wip5x1c7ng4e" />} data-id="element-4" data-mp="2wiyvintcfl9k" />
          <Route path="/villa/:id" element={<VillaDetails data-id="element-7" data-mp="28tmfb3zlmcxr" />} data-id="element-6" data-mp="2wi5m1f302hnq" />
          <Route path="/agent/login" element={<AgentLogin data-id="element-9" data-mp="28s30zixi6bym" />} data-id="element-8" data-mp="28sutulzptvl7" />
          <Route path="/agent" element={<AgentDashboard data-id="element-11" data-mp="23ujl6el5pr4k" />} data-id="element-10" data-mp="23vupcfiil0w7" />
          <Route path="/agent/new-booking" element={<AgentNewBooking data-id="element-13" data-mp="3ikr0s4yore8d" />} data-id="element-12" data-mp="23ti8y6semyl9" />
          <Route path="/admin" element={<AdminDashboard data-id="element-15" data-mp="3ii4qvyobommz" />} data-id="element-14" data-mp="3ijfu9xduvsdk" />
        </Routes>
      </main>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-16" data-mp="3rc9co3oln7vn">
      <BookingProvider data-id="element-17" data-mp="3rbrcwx2qabiz">
        <AppContent data-id="element-18" data-mp="3rdkg22e4udm8" />
      </BookingProvider>
    </BrowserRouter>;
}